export default "__VITE_ASSET__a379e28b__"